"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var components_1 = require("@athena-portal/components");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var React = require("react");
var FieldDisplay_1 = require("../../components/FieldDisplay");
var LookupFieldDisplay_1 = require("../../components/LookupFieldDisplay");
var Tree_1 = require("../../components/Tree");
var InsuredVehicleTree = /** @class */ (function (_super) {
    __extends(InsuredVehicleTree, _super);
    function InsuredVehicleTree() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates;
        _this.SOCIAL_AND_DOMESTIC_AND_COMMUTING = "SDP+C";
        _this.BUSINESS_USE_NON_COMMERCIAL = "BU-Class1";
        _this.OBJECT_ROLE_REGISTERED_KEEPER = "registeredKeeper";
        _this.OBJECT_ROLE_MAIN_DRIVER = "mainDriver";
        _this.OBJECT_ROLE_ADDITIONAL_DRIVER = "additionalDriver";
        _this.DATE_FORMAT = "DD/MM/YYYY";
        _this.VEHICLE_FUEL_TYPE_NAME = "vehicleFuelType";
        _this.VEHICLE_TRANSMISSION_NAME = "vehicleTransmission";
        _this.VEHICLE_MILEAGE_NAME = "mileage";
        _this.renderDateOfFirstRegistration = function () {
            if (_this.props.interactionVehicle.automotiveData !== undefined) {
                return ((0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "Date of first registration", value: _this.supportPortalTemplates.convertDate(_this.props.interactionVehicle.automotiveData.dateFirstRegistered, _this.DATE_FORMAT) }));
            }
            return;
        };
        _this.renderRegisteredKeeper = function () {
            var registeredKeeper = _this.props.drivers.filter(function (d) { return d.objectRole === _this.OBJECT_ROLE_REGISTERED_KEEPER; });
            if (registeredKeeper.length === 1) {
                var keeperName = registeredKeeper[0].firstName + " " + registeredKeeper[0].lastName;
                return ((0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "Registered keeper", value: keeperName }));
            }
            return;
        };
        _this.renderMainDriver = function () {
            var mainDriver = _this.props.drivers.filter(function (d) { return d.objectRole === _this.OBJECT_ROLE_MAIN_DRIVER; });
            if (mainDriver.length === 1) {
                var driverName = mainDriver[0].firstName + " " + mainDriver[0].lastName;
                return ((0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "Main driver", value: driverName }));
            }
            return;
        };
        _this.renderAdditionalDrivers = function () {
            var additionalDrivers = _this.props.drivers.filter(function (d) { return d.objectRole === _this.OBJECT_ROLE_ADDITIONAL_DRIVER; });
            if (additionalDrivers.length > 0) {
                var additionalDriversNames = additionalDrivers.map(function (driver, index) {
                    return index === additionalDrivers.length - 1 ? (0, jsx_runtime_1.jsxs)("span", { children: [driver.firstName, " ", driver.lastName] }, driver.id) : (0, jsx_runtime_1.jsxs)("span", { children: [driver.firstName, " ", driver.lastName, ", "] }, driver.id);
                });
                return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", { className: "muli-bold-16", children: "Additional drivers:" }), " ", additionalDriversNames] }));
            }
            return;
        };
        return _this;
    }
    InsuredVehicleTree.prototype.render = function () {
        var makeAndModel = this.props.vehicle.make + ", " + this.props.vehicle.model;
        var engineSize = this.props.interactionVehicle.lvVehicleData.engineSizeCc + "cc";
        return ((0, jsx_runtime_1.jsxs)(Tree_1.Tree, { label: "".concat(this.props.treeContentString), "data-visible": true, children: [(0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "Registration number", value: this.props.vehicle.registrationNumber }), (0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "Vehicle make and model", value: makeAndModel }), this.props.interactionVehicle && ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "Usage", value: this.getCarUsage() }), (0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "Engine size", value: engineSize }), this.renderDateOfFirstRegistration(), (0, jsx_runtime_1.jsx)(LookupFieldDisplay_1.LookupFieldDisplay, { label: "Fuel type", type: this.VEHICLE_FUEL_TYPE_NAME, id: this.props.interactionVehicle.fuelType }), (0, jsx_runtime_1.jsx)(LookupFieldDisplay_1.LookupFieldDisplay, { label: "Transmission type", type: this.VEHICLE_TRANSMISSION_NAME, id: this.props.interactionVehicle.transmission }), (0, jsx_runtime_1.jsx)(LookupFieldDisplay_1.LookupFieldDisplay, { label: "Mileage (entered by customer)", type: this.VEHICLE_MILEAGE_NAME, id: this.props.interactionVehicle.mileage }), (0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "Date of purchase", value: this.supportPortalTemplates.convertDate(this.props.interactionVehicle.purchaseDate, this.DATE_FORMAT) }), (0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "Overnight location postcode", value: this.props.overnightPostcode }), this.renderRegisteredKeeper(), this.renderMainDriver(), this.renderAdditionalDrivers()] }))] }));
    };
    InsuredVehicleTree.prototype.getCarUsage = function () {
        if (this.props.interactionVehicle.classOfUse !== undefined && this.props.interactionVehicle.classOfUse !== null) {
            // Annual product
            return this.props.interactionVehicle.classOfUse;
        }
        else if (this.props.interactionVehicle.businessUse !== undefined && this.props.interactionVehicle.businessUse !== null) {
            // Motor product
            return this.props.interactionVehicle.businessUse ? this.BUSINESS_USE_NON_COMMERCIAL : this.SOCIAL_AND_DOMESTIC_AND_COMMUTING;
        }
        else {
            return "";
        }
    };
    InsuredVehicleTree = __decorate([
        components_1.authorize
    ], InsuredVehicleTree);
    return InsuredVehicleTree;
}(React.Component));
exports.default = InsuredVehicleTree;
//# sourceMappingURL=InsuredVehicleTree.js.map